'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-fade';

import { IBranchPreview } from 'app/interfaces/branches';
import WithSwiper from 'app/components/common/WithSwiper';
import SwiperButtonPrev from 'app/components/common/SwiperButtonPrev';
import SwiperButtonNext from 'app/components/common/SwiperButtonNext';
import BranchCard from './BranchCard';

export default function BranchSlider({ items }: { items: IBranchPreview[] }) {
  return (
    <div className="relative">
      <Swiper
        modules={[EffectFade]}
        effect="fade"
        spaceBetween={-12}
        breakpoints={{
          768: {
            spaceBetween: -24
          },
          1280: {
            spaceBetween: -24
          },
          1920: {
            spaceBetween: 0
          }
        }}
      >
        {items.map((item, index) => {
          return (
            <SwiperSlide key={index} className="px-3 md:px-6 4xl:px-0">
              <BranchCard
                name={item.name}
                image={item.image_preview}
                url={`/branches/${item.slug}`}
              />
            </SwiperSlide>
          );
        })}
        <WithSwiper>
          {({ isLocked }) =>
            !isLocked && (
              <div className="absolute z-10 right-3 md:right-6 4xl:right-0 top-[calc(100vw_*_0.55_+_6px)] md:top-[calc(100vw_*_0.6_+_20px)] xl:top-[calc(100vw_*_0.32_+_20px)] 4xl:top-[calc(1920px_*_0.32_+_20px)] flex gap-1 justify-end">
                <SwiperButtonPrev />
                <SwiperButtonNext />
              </div>
            )
          }
        </WithSwiper>
      </Swiper>
    </div>
  );
}
